export default __webpack_public_path__ + "locales/en/JavascriptSdk.json?hash=dae9f0836f061a10e4a1f01562f253b1";